/** Permission keys for platform admin RBAC — keep in sync with PlatformPermissionCatalog.php */

export const PLATFORM_PERMISSION_GROUPS = [
  { key: 'dashboard', icon: 'ri-dashboard-line', perms: ['view_dashboard'] },
  { key: 'ateliers', icon: 'ri-store-2-line', perms: ['view_ateliers', 'add_atelier', 'edit_atelier', 'suspend_atelier', 'delete_atelier', 'login_as_atelier'] },
  { key: 'subscriptions', icon: 'ri-file-list-3-line', perms: ['view_subscriptions', 'edit_subscription', 'cancel_subscription', 'renew_subscription'] },
  { key: 'order_plans', icon: 'ri-shopping-bag-3-line', perms: ['view_order_plans', 'approve_order_plan', 'reject_order_plan', 'delete_order_plan'] },
  { key: 'demo_tenants', icon: 'ri-flask-line', perms: ['view_demo_tenants', 'add_demo_tenant'] },
  { key: 'payments', icon: 'ri-bank-card-line', perms: ['view_payments', 'refund_payment', 'mark_paid'] },
  { key: 'payment_gateways', icon: 'ri-secure-payment-line', perms: ['view_payment_gateways', 'add_payment_gateway', 'edit_payment_gateway', 'delete_payment_gateway'] },
  { key: 'plans', icon: 'ri-price-tag-3-line', perms: ['view_plans', 'add_plan', 'edit_plan', 'delete_plan'] },
  { key: 'flags', icon: 'ri-toggle-line', perms: ['view_flags', 'edit_flags'] },
  { key: 'support', icon: 'ri-customer-service-2-line', perms: ['view_tickets', 'reply_ticket', 'close_ticket'] },
  { key: 'users', icon: 'ri-team-line', perms: ['view_users', 'add_user', 'edit_user', 'delete_user'] },
  { key: 'admin_roles', icon: 'ri-shield-user-line', perms: ['view_admin_roles', 'add_admin_role', 'edit_admin_role', 'delete_admin_role'] },
  { key: 'reports', icon: 'ri-bar-chart-line', perms: ['view_reports', 'export_reports'] },
  { key: 'settings', icon: 'ri-settings-3-line', perms: ['view_settings', 'edit_settings'] },
  { key: 'notifs', icon: 'ri-notification-3-line', perms: ['view_notifications', 'send_notifications'] },
  { key: 'contact_messages', icon: 'ri-mail-unread-line', perms: ['view_contact_messages'] },
  {
    key: 'recruitment',
    icon: 'ri-briefcase-4-line',
    perms: [
      'view_recruitment',
      'manage_recruitment_jobs',
      'manage_recruitment_applications',
      'manage_recruitment_settings',
    ],
  },
  { key: 'logs', icon: 'ri-file-text-line', perms: ['view_logs'] },
  { key: 'marketing', icon: 'ri-megaphone-line', perms: ['view_marketing', 'edit_marketing'] },
  { key: 'integrations', icon: 'ri-plug-line', perms: ['view_integrations'] },
  {
    key: 'ai_sales',
    icon: 'ri-robot-2-line',
    perms: [
      'ai_sales.view',
      'ai_sales.inbox',
      'ai_sales.leads',
      'ai_sales.followups',
      'ai_sales.knowledge',
      'ai_sales.agent',
      'ai_sales.analytics',
      'ai_sales.manage',
    ],
  },
  {
    key: 'releases',
    icon: 'ri-git-branch-line',
    perms: ['view_releases', 'manage_releases', 'publish_releases'],
  },
] as const;

export const ALL_PLATFORM_PERMISSIONS: string[] = PLATFORM_PERMISSION_GROUPS.flatMap((g) => [...g.perms]);

/** Sidebar path → module view permission (locking the whole module). */
export const ROUTE_VIEW_PERMISSION: Record<string, string> = {
  '/dashboard': 'view_dashboard',
  '/ateliers': 'view_ateliers',
  '/subscriptions': 'view_subscriptions',
  '/order-plans': 'view_order_plans',
  '/demo-tenants': 'view_demo_tenants',
  '/expired-demo-tenants': 'view_demo_tenants',
  '/plans': 'view_plans',
  '/payments': 'view_payments',
  '/payment-gateways': 'view_payment_gateways',
  '/users': 'view_users',
  '/admin-roles': 'view_admin_roles',
  '/settings': 'view_settings',
  '/feature-flags': 'view_flags',
  '/support': 'view_tickets',
  '/notifications': 'view_notifications',
  '/messages': 'view_dashboard',
  '/recruitment/jobs': 'view_recruitment',
  '/recruitment/applications': 'view_recruitment',
  '/recruitment/settings': 'view_recruitment',
  '/logs': 'view_logs',
  '/integrations': 'view_integrations',
  '/marketing': 'view_marketing',
  '/intelligence': 'ai_sales.view',
  '/intelligence/conversations': 'ai_sales.inbox',
  '/intelligence/leads': 'ai_sales.leads',
  '/intelligence/follow-ups': 'ai_sales.followups',
  '/releases': 'view_releases',
};
